// extracted by mini-css-extract-plugin
export default {"root":"Video_root__lQBgo","PlayBtn":"Video_PlayBtn__GuXAV"};